import React, { useEffect, useState } from 'react';
import { alert, AlertType, Button, Input } from '@quyva/shared-ui';
import {
    faCheck,
    faClose,
    faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Toggle } from '@quyva/shared-ui';
import { TelegramSocketEvent } from './enums';

const isValidBotName = (name) => {
    // Must only contain letters, numbers, and underscores, and no spaces
    const validChars = /^[A-Za-z0-9_]+$/.test(name);

    // Must not contain '_bot' (case-insensitive)
    const containsBot = /_bot/i.test(name);

    // Must not start or end with '_'
    const startsOrEndsWithUnderscore = /^_|_$/.test(name);

    // Must not contain '__'
    const hasDoubleUnderscore = /__/.test(name);

    if (!validChars) {
        alert(
            AlertType.ERROR,
            'Only alphabets, numbers, and underscores are allowed (no spaces).'
        );

        return false;
    }
    if (containsBot) {
        alert(
            AlertType.ERROR,
            "Must not contain '_bot'. Already added for you"
        );

        return false;
    }
    if (startsOrEndsWithUnderscore) {
        alert(AlertType.ERROR, 'Must not start or end with an underscore.');

        return false;
    }
    if (hasDoubleUnderscore) {
        alert(AlertType.ERROR, 'Must not contain consecutive underscores.');

        return false;
    }

    return true;
};

export const BotCreationForm = ({
    user,
    socket,
    repository,
    setShowTelegramForm,
    botName,
    setBotName,
    setIsLoading,
    setLoadingText,
    onRefreshVirtualRepos,
}) => {
    const [botUsername, setBotUsername] = useState(`${repository.name}`);
    const [unrestrictedAccess, setUnrestrictedAccess] = useState(false);

    useEffect(() => {
        let modifiedName = botUsername.trim();
        setBotName(`${modifiedName}_bot`);
    }, [botUsername, setBotName]);

    return (
        <div className='w-full h-full flex flex-col'>
            <div className='flex items-center mb-6'>
                <div className='w-1/2 font-semibold text-texts-secondary300'>
                    <label htmlFor='botName'>Bot Name</label>
                </div>

                <div className='w-full'>
                    <div className='relative flex items-center'>
                        <Input
                            type={'text'}
                            value={botUsername}
                            placeholder={`${repository.name}`}
                            disabled={false}
                            onChange={(e) => {
                                const value = e.target.value;
                                setBotUsername(value);
                            }}
                        />
                        <span className='font-semibold text-texts-secondary300'>
                            _bot
                        </span>
                    </div>
                </div>
            </div>

            <div className='flex items-center mb-6'>
                <div className='w-2/4 font-semibold text-texts-secondary300'>
                    <label htmlFor='unrestrictedAccess'>
                        Unrestricted Access
                    </label>
                </div>

                <div className='w-full'>
                    <div className='relative w-full'>
                        <Toggle
                            checked={unrestrictedAccess}
                            onChange={(value) => {
                                setUnrestrictedAccess(value);
                            }}
                            toggleTextClassName={''}
                        />
                    </div>
                </div>
            </div>

            <div className='w-full flex items-center text-sm mb-2'>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className='mr-2 text-texts-tertiary400'
                    title='Information'
                />
                <span>
                    Please enter an unique name. Bot name ends with
                    <span className='mx-1.5 font-semibold'>_bot</span>in
                    telegram (already added for you).
                </span>
            </div>

            <div className='w-full flex items-center text-sm mb-8'>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className='mr-2 text-texts-tertiary400'
                    title='Information'
                />
                <span>
                    Unrestricted Access mean anyone can ask question from the
                    bot in telegram. They don't' need to be part of your
                    telegram group.
                </span>
            </div>

            <div className='w-full flex justify-end items-center'>
                <Button
                    text={'Cancel'}
                    icon={faClose}
                    type={'danger'}
                    hoverText={'Cancel Telegram Integration'}
                    onClick={() => {
                        const data = {
                            userMail: user.email,
                            repoName: repository.name,
                            repoId: repository.repoid,
                        };
                        socket.emit(
                            TelegramSocketEvent.DELETE_USER_SESSION,
                            data
                        );

                        setShowTelegramForm(false);
                        
                        if (onRefreshVirtualRepos) {
                            onRefreshVirtualRepos();
                        }
                    }}
                    className='mr-6'
                />

                <Button
                    text={'Create'}
                    icon={faCheck}
                    type={'success'}
                    hoverText={'Create a new telegram bot'}
                    onClick={(e) => {
                        if (isValidBotName(botUsername)) {
                            setLoadingText('Creating telegram bot...');
                            setIsLoading(true);

                            const data = {
                                userMail: user.email,
                                repoName: repository.name,
                                repoId: repository.repoid,
                                botName: botName,
                                unrestrictedAccess: unrestrictedAccess,
                            };
                            socket.emit(TelegramSocketEvent.BOT_CREATION, data);
                        }
                    }}
                    disabled={!botName.trim() ? true : false}
                />
            </div>
        </div>
    );
};
